export { default } from './FeaturedNewsBlock';
export * from './FeaturedNewsBlock';
